import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextService } from './text.service';
import { TextPipe } from './text.pipe';
import { HtmlPipe } from './html.pipe';
import { HtmlNoAbbrPipe } from './htmlNoAbbr.pipe';
import { ScreenreaderPipe } from './screenreader.pipe';
import { SimpleTextPipe } from './simpleText.pipe';
import { TierTextFormatPipe } from './tierTextFormat.pipe';
import { ModifyUmlautePipe } from './modifyUmlaute.pipe';
import { EnumToTextPipe } from './enumToTextPipe.pipe';

@NgModule({
  imports: [
    CommonModule,
    TextPipe,
    HtmlPipe,
    HtmlNoAbbrPipe,
    ScreenreaderPipe,
    SimpleTextPipe,
    TierTextFormatPipe,
    ModifyUmlautePipe,
    EnumToTextPipe,
  ],
  providers: [TextService],
  exports: [
    TextPipe,
    HtmlPipe,
    HtmlNoAbbrPipe,
    ScreenreaderPipe,
    SimpleTextPipe,
    TierTextFormatPipe,
    ModifyUmlautePipe,
    EnumToTextPipe,
  ],
})
export class TextServiceModule {}
